const variantName = 'navigationV4c'

export default {
  [variantName]: {
    container: {
      // ?============================
      // ?======== Container =========
      // ?============================
      position: 'fixed',
      width: '100%',
      top: '0px',
      left: '0px',
      zIndex: '1000',
      boxSizing: 'border-box',
      padding: ['0.5rem', '', '', '2rem 1rem'],
      display: 'flex',
      transition: 'all ease-in-out 0.5s',
      alignItems: 'center',
      justifyContent: 'flex-end',
      color: 'dark',
      '.seperatorLine': {
        margin: '1rem auto 1rem',
        width: '90%',
        maxWidth: '200px'
      }
    },
    containerScrolled: {
      variant: `${variantName}.container`,
      height: ['75px', '75px', '75px', 'unset'],
      padding: ['0.5rem', '', '', '0.75rem'],
      background: 'unset',
      backgroundColor: 'light',
      borderBottom: '1px solid black',
      '.logoLocationContainer': {
        position: ['', '', '', 'static'],
        margin: ['', '', '', '0 auto 0 0']
      },

      '.smallNavMenu': {
        color: 'dark'
      }
    },

    // ?============================
    // ?=======  Nav Logos =========
    // ?============================

    logoLocationContainer: {
      flexDirection: 'column',
      alignItems: 'center',
      padding: '0.25rem 1rem',
      height: '100%',
      position: ['', '', '', 'absolute'],
      top: '1rem',
      left: ['', '', '', '2rem'],
      textAlign: 'center',
      display: ['inline-block', '', '', '']
    },

    locationSwitcher: {
      backgroundColor: '',
      zIndex: '2000',
      alignSelf: 'flex-start',
      button: {
        backgroundColor: 'unset',
        borderTop: '1px solid',
        borderRadius: '0px'
      },
      '.popUp': {
        transform: ['', '', '', 'translateX(-45%)']
      },
      '.popUp .content': {
        backgroundColor: 'rgb(255 255 255 / 74%)'
      }
    },

    logo: {
      marginBottom: '0rem',
      zIndex: '2000',
      transition: 'all ease-in-out 0.4s',
      justifyContent: 'center',
      img: {
        filter: 'brightness(0) invert(1)',
        maxHeight: ['60px', '', '150px']
      }
    },
    logoScrolled: {
      variant: `${variantName}.logo`,
      maxHeight: ['100%'],
      height: ['100%'],
      display: ['inline-block', '', '', 'inline'],
      textAlign: 'left',
      a: {
        display: ['inline-block', '', '', 'inline'],
        alignItems: 'center'
      },
      img: {
        filter: 'unset',
        height: ['100%'],
        maxHeight: ['100%', '80px'],
        padding: 0
      }
    },

    navMenuLogo: {
      img: {
        maxHeight: ['60px', '', '100px', '']
      },
      marginBottom: '1rem'
    },

    // ?============================
    // ?=======  Hamburger =========
    // ?============================

    hamburger: {
      position: 'relative',
      display: ['flex', 'flex', 'flex', ''],
      zIndex: '2600',
      alignSelf: 'center',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: '50px',
      height: '50px',
      padding: '0.5rem',
      cursor: 'pointer',
      margin: ['0 0.5rem 0 auto', '', '', '0rem 0.75rem'],
      minWidth: '30px',
      border: 'solid 1px',
      borderColor: 'primary',
      div: {
        alignSelf: 'flex-end',
        transition: 'all ease-in-out 0.3s',
        height: '4px',
        width: '100%',
        backgroundColor: 'primary'
      }
    },
    hamburgerOpen: {
      variant: `${variantName}.hamburger`,
      height: '50px',
      width: '50px',
      padding: '0.5rem',
      div: {
        position: 'absolute',
        boxShadow: 'none',
        transition: 'all ease-in-out 0.3s',
        height: '4px',
        width: '100%',
        backgroundColor: 'primary',
        borderRadius: '10px',
        top: '50%',
        left: '50%'
      },
      '& > div:nth-of-type(1)': {
        transform: 'translateX(-50%) rotate(135deg) '
      },
      '& > div:nth-of-type(2)': {
        transform: 'translateX(-50%) rotate(-135deg)'
      }
    },

    // ?============================
    // ?========  Nav Menu =========
    // ?============================

    navMenu: {
      position: ['absolute', 'absolute', 'absolute'],
      margin: '0px',
      boxSizing: 'border-box',
      justifyContent: ['center', 'center', 'center'],
      backgroundColor: ['background'],
      zIndex: '2500',
      width: ['100%'],
      height: '0vh',
      minWidth: '250px',
      top: '-100vh',
      transform: 'rotate3d(1, 1, 1, 360deg)',
      right: '100vh',
      transition: 'all ease-in-out 1s',
      padding: ['0.5rem'],
      alignItems: ['center', 'center', 'center', 'center'],
      textAlign: 'center',
      display: 'flex',
      flexDirection: ['column', 'column', 'column'],
      overflow: 'hidden',
      listStyleType: 'none'
      // clipPath: 'polygon(80% 0, 100% 0%, 100% 14%, 97% 3%);',
    },

    // when nav is open it uses this variant
    navMenuOpen: {
      variant: `${variantName}.navMenu`,
      right: '0%',
      top: '0%',
      height: '100vh',
      transform: 'rotate3d(1, 1, 1, 0deg)'
      // clipPath: 'polygon(0 0, 100% 0%, 100% 100%, 0 100%)',
    },

    navItem: {
      margin: ['0.35rem', '0.75rem', '', '0.5rem'],
      zIndex: '100',
      listStyleType: 'none',
      a: {
        fontSize: ['1.2rem', '', '', '1.75rem', '2rem'],
        textTransform: 'uppercase',
        fontWeight: '500',
        letterSpacing: '2px',
        textDecoration: 'none',
        ':hover': {
          color: 'secondary'
        }
      }
    },

    smallNavMenu: {
      display: ['none', '', '', 'flex'],
      color: 'light',
      li: {
        a: {
          fontSize: ['1.2rem', '', '', '1rem', '1rem']
        }
      }
    },

    smallNavHeading: {
      fontSize: ['1rem', '', '1.5rem'],
      marginBottom: '0.5rem',
      fontFamily: 'display',
      fontWeight: '500',
      color: 'primary'
    },

    // ?==========================
    // ?====  Dropdown Styles ====
    // ?==========================

    navItemDropdown: {
      alignItems: 'inherit',
      fontFamily: 'inherit',
      justifyContent: 'inherit',
      position: 'relative',
      cursor: 'pointer'
    },

    subNavItemDropdown: {
      variant: `${variantName}.navItem`,
      padding: '0.5rem',
      margin: ['0rem', '0rem', '0rem', '0rem'],
      whiteSpace: 'nowrap'
    },

    navItemDropdownMenu: {
      padding: '0.5rem',
      textShadow: '0px 0px 30px rgb(122 122 122 / 79%)',
      position: ['', '', '', 'absolute'],
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit',
      flexDirection: 'column',
      width: '100%',
      backgroundColor: 'primary'
    },

    // ?==========================
    // ?=====  Nav Widgets  ======
    // ?==========================

    phoneContainerDesktop: {
      display: ['none', '', '', ''],
      borderRight: 'solid 1px',
      borderColor: 'secondary',
      paddingRight: '0.75rem',
      a: {
        transition: 'all ease-in-out 0.5s',
        ':hover': {
          color: 'secondary',
          fontSize: '1.1rem'
        }
      }
    },

    socialIconsContainerDesktop: {
      display: ['none', '', '', ''],
      padding: '0.5rem 1rem',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      margin: ['', '', '', '0 auto 0 0'],
      a: {
        display: 'flex',
        textAlign: 'center',
        padding: '0.5rem',
        alignItems: 'center',
        transition: 'all ease-in-out 0.5s',
        ':hover': {
          transform: 'scale(1.5)',
          svg: {
            path: { fill: 'secondary' }
          }
        }
      }
    },

    phoneSocialContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      width: '100%',
      maxWidth: '450px'
    },

    phoneContainer: {
      padding: '0.25rem',
      width: '50%',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      // borderRight: '2px solid',
      // borderColor: 'secondary',
      a: {
        display: 'flex',
        padding: '0.5rem',
        alignItems: 'center',
        fontSize: '0.8rem',
        textAlign: 'center',
        justifyContent: 'center',
        svg: {
          marginRight: '0.25rem'
        }
      }
    },

    socialIconsContainer: {
      padding: '0.25rem',
      flexDirection: 'column',
      alignItems: 'center',
      width: '50%',
      textAlign: 'center',
      a: {
        display: 'flex',
        textAlign: 'center',
        padding: '0.5rem',
        alignItems: 'center'
      },
      svg: {
        path: { fill: 'dark' }
      }
    },

    // ?==========================
    // ?=====  Nav Block  ======
    // ?==========================

    navBlock: {
      display: 'flex',
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
      position: 'absolute',
      margin: '0rem',
      zIndex: '500',
      transition: 'all ease-in-out 0.5s',
      top: '0rem',
      right: '-200%',
      width: ['100vw', '100vw', '100vw', '100vw'],
      height: ['100vh', '100vh', '100vh', '100vh']
    },
    navBlockOpen: {
      variant: `${variantName}.navBlock`,
      right: '0rem',
      top: '0rem'
    }
  }
}
